import { render, staticRenderFns } from "./CreatePlanModal.vue?vue&type=template&id=2bbf6379"
import script from "./CreatePlanModal.vue?vue&type=script&lang=js"
export * from "./CreatePlanModal.vue?vue&type=script&lang=js"
import style0 from "./CreatePlanModal.vue?vue&type=style&index=0&id=2bbf6379&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports